// @flow
import pinCloseupDetailsHook from 'app/common/lib/TraceLogger/customEventHooks/pinCloseupDetailsHook';
import type { DesktopTraceEventHandlerOptions as HandlerOptions } from 'app/common/lib/TraceLogger/types';

const UNAUTH_SOCIAL_AUTOLOGIN_ANNOTATIONS = [
  'UnauthFacebookAutologinStartEvent',
  'UnauthFacebookAutologinScriptLoadEvent',
  'UnauthFacebookAutologinSuccessEvent',
  'UnauthGoogleAutologinStartEvent',
  'UnauthGoogleAutologinSuccessEvent',
  'UnauthGoogleOneTapMountEvent',
];

const CONFIG: $ReadOnlyArray<HandlerOptions> = [
  {
    traceName: 'pwt/board_page_load',
    metricName: PCONST.thrift.TracingClientTypes.PWTAction.BOARD_PAGE_LOAD,
    triggeredBy: 'clientRouter',
    viewType: PCONST.thrift.ViewType.BOARD,
    viewParameter: PCONST.thrift.ViewParameterType.USER_BOARDS,
    measureMasonry: true,
  },
  {
    traceName: 'pwt/board_picker',
    metricName: PCONST.thrift.TracingClientTypes.PWTAction.BOARD_PICKER,
    triggeredBy: 'component',
    viewType: PCONST.thrift.ViewType.BOARD_PICKER,
    sampleRate: 0.1,
  },
  {
    traceName: 'pwt/pin_closeup_details',
    metricName: PCONST.thrift.TracingClientTypes.PWTAction.PIN_CLOSEUP_DETAILS,
    triggeredBy: 'clientRouter',
    annotations: ['CloseupMetadataRenderedTraceEvent', 'PageReactRouterOnChangeTraceEvent'],
    viewType: PCONST.thrift.ViewType.PIN,
    sampleRate: 0.1,
    experimentNames: ['web_eg_closeup_related_upsell'],
    customEventHooks: [pinCloseupDetailsHook],
  },
  {
    traceName: 'pwt/grid_bottom_spinner',
    metricName: PCONST.thrift.TracingClientTypes.PWTAction.GRID_BOTTOM_SPINNER,
    triggeredBy: 'component',
    viewType: PCONST.thrift.ViewType.PIN, // Not sure what the viewType should be for grid bottom spinner
    sampleRate: 0.1,
  },
  {
    traceName: 'pwt/home_feed_render',
    metricName: PCONST.thrift.TracingClientTypes.PWTAction.HOME_FEED_RENDER,
    triggeredBy: 'clientRouter',
    viewType: PCONST.thrift.ViewType.FEED,
    viewParameter: PCONST.thrift.ViewParameterType.FEED_HOME,
    measureMasonry: true,
  },
  {
    traceName: 'pwt/pin_builder_apply_templates',
    metricName: PCONST.thrift.TracingClientTypes.PWTAction.PIN_BUILDER_APPLY_TEMPLATES,
    triggeredBy: 'clientRouter',
    viewType: PCONST.thrift.ViewType.PIN_BUILDER,
  },
  {
    traceName: 'pwt/pin_builder_publish_pins',
    metricName: PCONST.thrift.TracingClientTypes.PWTAction.PIN_BUILDER_PUBLISH_PINS,
    triggeredBy: 'clientRouter',
    viewType: PCONST.thrift.ViewType.PIN_BUILDER,
  },
  {
    traceName: 'pwt/pin_builder_publish_pin',
    metricName: PCONST.thrift.TracingClientTypes.PWTAction.PIN_BUILDER_PUBLISH_PIN,
    triggeredBy: 'clientRouter',
    viewType: PCONST.thrift.ViewType.PIN_BUILDER,
  },
  {
    traceName: 'pwt/other_profile',
    metricName: PCONST.thrift.TracingClientTypes.PWTAction.OTHER_PROFILE,
    triggeredBy: 'clientRouter',
    viewType: PCONST.thrift.ViewType.USER,
    viewParameter: PCONST.thrift.ViewParameterType.USER_OTHERS,
    measureMasonry: true,
  },
  {
    traceName: 'pwt/own_profile',
    metricName: PCONST.thrift.TracingClientTypes.PWTAction.OWN_PROFILE,
    triggeredBy: 'clientRouter',
    viewType: PCONST.thrift.ViewType.USER,
    viewParameter: PCONST.thrift.ViewParameterType.USER_SELF,
    endTimeConstraints: [
      'ArchivedBoardsListMountedTraceEvent',
      'PublicBoardsListMountedTraceEvent',
      'SecretBoardsListMountedTraceEvent',
    ],
    measureMasonry: true,
  },
  {
    traceName: 'pwt/search_feed_render',
    metricName: PCONST.thrift.TracingClientTypes.PWTAction.SEARCH_FEED_RENDER,
    triggeredBy: 'clientRouter',
    viewType: PCONST.thrift.ViewType.SEARCH,
    viewParameter: PCONST.thrift.ViewParameterType.SEARCH_PINS,
    experimentNames: ['web_eg_search_loading_state'],
    annotations: ['ShoppingSearchPivot'],
    measureMasonry: true,
  },
  {
    traceName: 'pwt/home_feed_pinteractive',
    metricName: PCONST.thrift.TracingClientTypes.PWTAction.HOME_FEED_PINTERACTIVE,
    triggeredBy: 'pageLoad',
    annotations: [
      'InitialRouteWillMatchTraceEvent',
      'InitialRouteDidMatchTraceEvent',
      'RenderReactContainerTraceEvent',
    ],
    viewType: PCONST.thrift.ViewType.FEED,
    viewParameter: PCONST.thrift.ViewParameterType.FEED_HOME,
    endTimeConstraints: ['SearchBoxEnabledTraceEvent', 'AuthHFComponentDidMountTraceEvent'],
    experimentNames: ['web_masonry9_homepage', 'web_grid_immersive'],
    measureMasonry: true,
  },
  {
    traceName: 'pwt/pin_builder_page_load',
    metricName: PCONST.thrift.TracingClientTypes.PWTAction.PIN_BUILDER_PAGE_LOAD,
    triggeredBy: 'pageLoad',
    viewType: PCONST.thrift.ViewType.PIN_BUILDER,
  },
  {
    traceName: 'pwt/scaled_pin_builder_page_load',
    metricName: PCONST.thrift.TracingClientTypes.PWTAction.SCALED_PIN_BUILDER_PAGE_LOAD,
    triggeredBy: 'pageLoad',
    viewType: PCONST.thrift.ViewType.PIN_BUILDER,
  },
  {
    traceName: 'pwt/board_page_interactive',
    metricName: PCONST.thrift.TracingClientTypes.PWTAction.BOARD_PAGE_INTERACTIVE,
    triggeredBy: 'pageLoad',
    viewType: PCONST.thrift.ViewType.FEED,
    endTimeConstraints: ['UnauthBoardInteractiveTraceEvent'],
    experimentNames: ['web_unauth_blp_ssr'],
    annotations: UNAUTH_SOCIAL_AUTOLOGIN_ANNOTATIONS,
    measureMasonry: true,
  },
  {
    traceName: 'pwt/klp_page_interactive',
    metricName: PCONST.thrift.TracingClientTypes.PWTAction.KLP_PAGE_INTERACTIVE,
    triggeredBy: 'pageLoad',
    viewType: PCONST.thrift.ViewType.FEED,
    viewParameter: PCONST.thrift.ViewParameterType.FEED_KLP,
    endTimeConstraints: ['UnauthKLPInteractiveTraceEvent'],
    measureMasonry: true,
  },
  {
    traceName: 'pwt/pin_page_interactive',
    metricName: PCONST.thrift.TracingClientTypes.PWTAction.PIN_PAGE_INTERACTIVE,
    triggeredBy: 'pageLoad',
    viewType: PCONST.thrift.ViewType.FEED,
    endTimeConstraints: [
      'UnauthPinInteractiveTraceEvent',
      'PinPageMainImageRenderedTraceEvent',
      'UnauthRenderSimilarPinsTraceEvent',
      'MasonryDidMount',
    ],
    experimentNames: ['web_unauth_pin_page_node'],
    annotations: ['PageReactRouterOnChangeTraceEvent', ...UNAUTH_SOCIAL_AUTOLOGIN_ANNOTATIONS],
  },
  {
    traceName: 'pwt/user_page_interactive',
    metricName: PCONST.thrift.TracingClientTypes.PWTAction.USER_PAGE_INTERACTIVE,
    triggeredBy: 'pageLoad',
    viewType: PCONST.thrift.ViewType.FEED,
    endTimeConstraints: ['UnauthProfileInteractiveTraceEvent'],
  },
  // Ads metrics
  {
    traceName: 'pwt/sterling_signup_main_pageload',
    metricName: PCONST.thrift.TracingClientTypes.PWTAction.STERLING_SIGNUP_MAIN_PAGELOAD,
    triggeredBy: 'pageLoad',
    viewType: PCONST.thrift.ViewType.REGISTRATION,
  },
  {
    traceName: 'pwt/sterling_login_main_pageload',
    metricName: PCONST.thrift.TracingClientTypes.PWTAction.STERLING_LOGIN_MAIN_PAGELOAD,
    triggeredBy: 'pageLoad',
    viewType: PCONST.thrift.ViewType.BUSINESS_LOGIN,
  },
  {
    traceName: 'pwt/sterling_billingprofile_main_pageload',
    metricName: PCONST.thrift.TracingClientTypes.PWTAction.STERLING_BILLINGPROFILE_MAIN_PAGELOAD,
    triggeredBy: 'pageLoad',
    viewType: PCONST.thrift.ViewType.STERLING_BILLING_FLOW_V2,
  },
  {
    traceName: 'pwt/sterling_adsedit_main_pageload',
    metricName: PCONST.thrift.TracingClientTypes.PWTAction.STERLING_ADSEDIT_MAIN_PAGELOAD,
    triggeredBy: 'pageLoad',
    viewType: PCONST.thrift.ViewType.STERLING_EDIT_FLOW,
  },
  {
    traceName: 'pwt/sterling_bulkeditor_main_pageload',
    metricName: PCONST.thrift.TracingClientTypes.PWTAction.STERLING_BULKEDITOR_MAIN_PAGELOAD,
    triggeredBy: 'pageLoad',
    viewType: PCONST.thrift.ViewType.STERLING_BULK_EDITOR_V2,
  },
  {
    traceName: 'pwt/sterling_adsduplication_main_pageload',
    metricName: PCONST.thrift.TracingClientTypes.PWTAction.STERLING_ADSDUPLICATION_MAIN_PAGELOAD,
    triggeredBy: 'pageLoad',
    viewType: PCONST.thrift.ViewType.STERLING_DUPLICATION_FLOW_V2,
  },
  {
    traceName: 'pwt/sterling_adscreate_main_pageload',
    metricName: PCONST.thrift.TracingClientTypes.PWTAction.STERLING_ADSCREATE_MAIN_PAGELOAD,
    triggeredBy: 'pageLoad',
    viewType: PCONST.thrift.ViewType.STERLING_CREATE_FLOW,
  },
  {
    traceName: 'pwt/sterling_adscreate_pinbuilder_pageload',
    metricName: PCONST.thrift.TracingClientTypes.PWTAction.STERLING_ADSCREATE_PINBUILDER_PAGELOAD,
    triggeredBy: 'pageLoad',
    viewType: PCONST.thrift.ViewType.PIN_BUILDER,
  },
  {
    traceName: 'pwt/sterling_reporting_details_pageload',
    metricName: PCONST.thrift.TracingClientTypes.PWTAction.STERLING_REPORTING_DETAILS_PAGELOAD,
    triggeredBy: 'pageLoad',
    viewType: PCONST.thrift.ViewType.STERLING_REPORTING_DASHBOARD,
  },
  {
    traceName: 'pwt/sterling_reporting_overview_pageload',
    metricName: PCONST.thrift.TracingClientTypes.PWTAction.STERLING_REPORTING_OVERVIEW_PAGELOAD,
    triggeredBy: 'pageLoad',
    viewType: PCONST.thrift.ViewType.STERLING_HOME,
  },
];

export default CONFIG;
